import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { PersistConfig, persistReducer, persistStore } from 'redux-persist';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist/es/constants';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import config from 'config';

import { rootReducer, RootState } from './reducers';

const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  storage,
  whitelist: ['streamingPlatforms', 'callbackTriggers'],
  version: 1
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const init = () => {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => {
      const middleware = getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
        }
      });

      if (['local', 'development'].includes(config.app.env)) {
        middleware.concat(logger);
      }

      return middleware;
    },
    devTools: ['local', 'development'].includes(config.app.env)
  });

  const persistor = persistStore(store);

  return { store, persistor };
};

export default init;
